import axios from "axios"

function getStudyProgramsAsStudent() {
    return axios.get("/api/v1/study-programs")
}

function getStudyProgramsAsTutor({ id }, {}, params) {
    if (!id) return axios.get(`/api/v1/students/study-programs`, { params })
    else return axios.get(`/api/v1/students/${id}/study-programs`, { params })
}

function getStudyProgram({ id }) {
    return axios.get(`/api/backoffice/study-programs/${id}`)
}

export const studyProgramsService = {
    getStudyProgramsAsStudent,
    getStudyProgramsAsTutor,
    getStudyProgram,
}
